import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import {getFirestore} from "firebase/firestore"

//import firebase from "firebase"
const firebaseConfig = {
  apiKey: "AIzaSyDTwHOVzF-TIMSYaj96M3rpfYY-cjTz9po",
  authDomain: "jchessmanager.firebaseapp.com",
  databaseURL: "https://jchessmanager-default-rtdb.firebaseio.com",
  projectId: "jchessmanager",
  storageBucket: "jchessmanager.firebasestorage.app",
  messagingSenderId: "372219015910",
  appId: "1:372219015910:web:37fee75e2edab81d448127",
  measurementId: "G-S75XF1YS2X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const databaseMiApp = getDatabase(app);
const firestoreMiApp = getFirestore(app);

export {app, databaseMiApp, firestoreMiApp, auth};